import { Features, Footer, Hero, Pricing, Testimonials } from "../components";
import { Helmet } from "react-helmet-async";
import { pageSEO } from "../config/seo.config";

const Home = () => {
  const a = [
    "font-display",
    "font-cursive",
    "font-qwitcher",
    "font-cursive",
    "font-saint",
    "font-doulaise",
    "font-italianno",
    "font-fleur",
    "font-gwendolyn",
    "font-lovers",
    "font-montecarlo",
    "font-parisienne",
    "font-windsong",
    "font-amatic",
    "font-annie",
    "font-caveat",
    "font-cinzel",
    "font-delicious",
    "font-gruppo",
    "font-indie",
    "font-oooh",
    "font-patrick",
    "font-poiret",
    "font-sacramento",
    "font-taviraj",
  ];
  return (
    <>
      <Helmet>
        <title>{pageSEO.home.title}</title>
        <meta name="description" content={pageSEO.home.description} />
        <meta property="og:title" content={pageSEO.home.title} />
        <meta property="og:description" content={pageSEO.home.description} />
        <link rel="canonical" href="https://pozivnica.hr" />
      </Helmet>
      <Hero />
      <Features />
      <Testimonials />
      <Pricing />
      <Footer />
      {a.map((el) => (
        <p key={el} className={`${el} hidden`}>
          Test
        </p>
      ))}
    </>
  );
};

export default Home;
